import { createTheme, Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system/styleFunctionSx';

export type TShadow =
  | 'DARK'
  | 'LIGHT'
  | 'NONE'
  | 'GOLD'
  | 'SILVER'
  | 'BRONZE'
  | 'ERROR'
  | 'SUCCESS'
  | 'MORE_DARK';

export type TMaterialStyleItem = SystemStyleObject<Theme>;

export type TMaterialStyleProp = TMaterialStyleItem | TMaterialStyleItem[];

export type TMaterialStyles = {
  [key: string]: TMaterialStyleItem;
};

type TPaletteUtils = {
  gradients: {
    gold: string;
    silver: string;
    bronze: string;
  };
};

type TPaletteDefaultOption = {
  shadow?: string;
  main?: string;
};

declare module '@mui/material/styles' {
  interface Palette {
    utils: TPaletteUtils;
    gold: TPaletteDefaultOption;
    silver: TPaletteDefaultOption;
    bronze: TPaletteDefaultOption;
    lightGreen: TPaletteDefaultOption;
  }
  interface PaletteOptions {
    utils: TPaletteUtils;
    gold: TPaletteDefaultOption;
    silver: TPaletteDefaultOption;
    bronze: TPaletteDefaultOption;
    lightGreen: TPaletteDefaultOption;
  }
}

const theme = createTheme({
  cssVariables: true,
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 425,
      lg: 1024,
      xl: 1440,
    },
  },
  palette: {
    primary: {
      main: '#4DA2FF',
      dark: '#105BAE',
      contrastText: '#83B7EF',
    },
    secondary: {
      main: '#105BAE',
      dark: '#083A72',
      contrastText: '#0E3C6F',
    },
    error: {
      main: '#FF5A44',
      dark: '#832215',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#000000',
    },
    success: {
      main: '#01B659',
      dark: '#026733',
      light: '#38F571',
      contrastText: '#10AE4D',
    },
    grey: {
      50: '#0B0D0F',
      100: '#11222B',
      200: '#233A46',
      300: '#676767ba',
      400: '#9b9b9bfc',
      500: '#6d6d6dfc',
      600: '#07386D',
      700: '#05274A',
      800: '#002A58',
      900: '#0049A9',
    },
    gold: {
      shadow: '#905F08',
    },
    bronze: {
      shadow: '#6D3516',
    },
    silver: {
      shadow: '#344F64',
    },
    lightGreen: {
      main: '#4DFF62',
    },
    utils: {
      gradients: {
        gold: 'linear-gradient(45deg, #DC9C07, #E29A1E, #FFDA6B, #F0AF30, #E29A1E, #FFCD38, #DD931A);',
        silver:
          'linear-gradient(45deg, #7DB0CF, #8FB9DC, #BFE2FF, #5B7A8D, #698999, #81AACB, #4A758A)',
        bronze:
          'linear-gradient(45deg, #E86E42, #B25725, #D96F36, #B24B13, #D26226, #FFA574, #BE5528)',
      },
    },
  },
});

export default theme;
